const features = [
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    desc: '官方认证入口，SSL加密传输，全方位保护您的隐私与数据安全。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '每日海量内容更新，第一时间呈现最新热门资源，永不落伍。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全平台支持',
    desc: '支持Windows、Mac、iOS、Android，随时随地畅享精彩内容。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '贴心服务',
    desc: '7x24小时在线客服，专业团队极速响应，用心解决每个问题。',
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            为什么选择<strong>8x8x水蜜桃</strong>
          </h2>
          <p className="mt-3 text-foreground-500 max-w-xl mx-auto">
            四大核心优势，打造极致内容体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group p-6 rounded-2xl bg-background-100 hover:bg-primary-50 transition-all duration-300 cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 mb-4">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}